import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=830cbdde&scoped=true"
import script from "./CheckForm.vue?vue&type=script&lang=js"
export * from "./CheckForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830cbdde",
  null
  
)

export default component.exports